import classNames from "classnames"
import PropTypes from "prop-types"
import React from "react"

import Lightbox from "../lightbox/lightbox"
import { GalleryItem } from "../model/gallery-item"
import "./default-gallery.sass"
import ImagePreview from "./image-preview/image-preview"
import VideoPreview from "./video-preview/video-preview"
import ZoomImagePreview from "./zoom-image-preview/zoom-image-preview"

const getGalleryContent = (item) => {
  switch (item.type) {
    case "VIDEO":
      return <VideoPreview galleryVideo={item} />
    case "PICTURE":
      return <ImagePreview galleryPicture={item} />
    case "ZOOM_PICTURE":
      return <ZoomImagePreview galleryPicture={item} />
    default:
      return <></>
  }
}

class DefaultGallery extends React.Component {
  open = () => {}

  render() {
    return (
      <>
        <Lightbox
          onMount={({ open }) => (this.open = open)}
          items={this.props.items}
        />
        {this.props.items && this.props.items.length > 0 && (
          <div
            className={classNames("_fp-default-gallery", {
              "_fp-default-gallery--large-preview": this.props.showLargePreview,
            })}
          >
            {this.props.items
              .slice(
                0,
                this.props.showLargePreview ? 4 : this.props.items.length,
              )
              .map((item, index) => {
                return (
                  <button
                    key={`default_gallery_item_${index}`}
                    className="_fp-default-gallery__preview"
                    onClick={() => this.open(item)}
                  >
                    {getGalleryContent(item)}
                  </button>
                )
              })}
          </div>
        )}
      </>
    )
  }
}

DefaultGallery.propTypes = {
  items: PropTypes.arrayOf(PropTypes.instanceOf(GalleryItem)).isRequired,
  showLargePreview: PropTypes.bool,
}

DefaultGallery.defaultProps = {
  showLargePreview: false,
}

export default DefaultGallery
